import { MenuItem } from "../../Type/Layout/Sidebar";

export const MenuList: MenuItem[] = [
  {
    title: "",
    Items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "Home",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
        // badge: "3",
      },
      {
        title: "Employee",
        id: 2,
        icon: "User",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/employee`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/employee`,
            title: "Employee",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/employee/dayLocked`,
            title: "Day Locked",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/employee/accountLocked`,
            title: "Account Locked",
            type: "link",
          },

          {
            path: `${process.env.PUBLIC_URL}/employee/documentaccountlocked`,
            title: "Document Account Locked",
            type: "link",
          },{
            path: `${process.env.PUBLIC_URL}/employee/Position`,
            title: "Position",
            type: "link",
          },
        ],
      },
      {
        title: "Leave Management",
        id: 3,
        icon: "Calendar",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/leave/leaverequest`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/leave/leaverequest`,
            title: "Leave Request",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/leave/leavetype`,
            title: "Leave Type",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/leave/leaveconfiguration`,
            title: "Leave Configuration",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/leave/leaveBalance`,
            title: "Leave Balance",
            type: "link",
          },
        ],
      },
      {
        title: "Announcement",
        id: 4,
        icon: "Calendar",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/announcement`,
      },
      {
        title: "Onboarding",
        id: 6,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/onboarding/requests`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/onboarding/requests`,
            title: "Requests",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/onboarding/onboardingform`,
            title: "Onboarding Forms",
            type: "link",
          },
          {
            // path: `${process.env.PUBLIC_URL}/onboarding/configuration`,
            path: `${process.env.PUBLIC_URL}/onboarding/onboarding_org_list`,
            title: "Configuration",
            type: "link",
          },
        ],
      },
      {
        title: "MTP",
        id: 7,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/mtp`,
        children: [
          { path: `${process.env.PUBLIC_URL}/mtp`, title: "MTP", type: "link" },

        ],
      },
      {
        title: "STP",
        id: 28,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/stp`,
        children: [
         
          { path: `${process.env.PUBLIC_URL}/stp`, title: "STP", type: "link" },
        ],
      },
      {
        title: "Product Catalogue",
        id: 8,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/catalogue/categories`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/catalogue/categories`,
            title: "Categories",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/catalogue/products`,
            title: "Products",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/catalogue/pricebooks`,
            title: "Price books",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/catalogue/tags`,
            title: "Tags",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/catalogue/brands`,
            title: "Brands",
            type: "link",
          },
          // {
          //   path: `${process.env.PUBLIC_URL}/catalogue/notificationconfigure`,
          //   title: "Notification Configure",
          //   type: "link",
          // },
        ],
      },
      {
        title: "Notification Configuration",
        id: 9,
        icon: "Bell",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/notificationconfigure`,
      },
      {
        title: "Brand Campaign",
        id: 10,
        icon: "Calendar",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/brandcampaign`,
      },
      {
        title: "Customer Management",
        id: 11,
        icon: "Profile",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/customer/CustomerByOrgUnit`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/customer/CustomerByOrgUnit`,
            title: "Customers",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/classifications/classifications`,
            title: "Classifications",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/customerTag/customerTag`,
            title: "CustomerTag",
            type: "link",
          },
        ],
      },
      {
        title: "POB",
        id: 12,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/pobOrdersList`,
      },
      {
        title: "E-Detailing",
        id: 13,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/edetailing/playlisttypes`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/edetailing/playlisttypes`,
            title: "Playlist Types",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/edetailing/presentation`,
            title: "Presentation",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/edetailing/edplaylist`,
            title: "Ed Playlist",
            type: "link",
          },
        ],
      },
      {
        title: "File Management",
        id: 14,
        icon: "Profile",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/filesmanagement/folders`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/filesmanagement/folders`,
            title: "Folders",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/filesmanagement/files`,
            title: "Document",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/filesmanagement/mediaconfig`,
            title: "Media Config",
            type: "link",
          },
        ],
      },
      {
        title: "FSM",
        id: 15,
        icon: "Paper",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/org_list`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/org_list`,
            title: "Territories",
            type: "link",
          },
          // {
          //   path: `${process.env.PUBLIC_URL}/territories`,
          //   title: "Territories",
          //   type: "link",
          // },
          {
            path: `${process.env.PUBLIC_URL}/beats`,
            title: "Beats/Patches",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/subscriberType`,
            title: "Subscriber Type",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/leadType`,
            title: "Lead Type",
            type: "link",
          },
        ],
      },
      {
        title: "Expenses",
        id: 16,
        icon: "Wallet",
        type: "sub",
        active: false, // ✅
        path:
          `${process.env.PUBLIC_URL}/expense/expenses` ||
          `${process.env.PUBLIC_URL}/expense/expenses/employeeList`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/expense/expenses`,
            title: "Expenses",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/expAudit`,
            title: "Audit",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/expGeoDistance`,
            title: "Geo Distance",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/expNotify`,
            title: "Expense Notify",
            type: "link",
          },
        ],
      },
      {
        title: "Configuration",
        id: 17,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/expenseScreen`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/expenseScreen`,
            title: "Expense Head",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/agendaScreen`,
            title: "Agenda",
            type: "link",
          },

          // { path: `${process.env.PUBLIC_URL}/expensehead`, title: "Expense Head", type: "link" },

          // { path: `${process.env.PUBLIC_URL}/master`, title: "Grade Master", type: "link" },
          {
            path: `${process.env.PUBLIC_URL}/configuration/grademaster`,
            title: "Grade Master",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/configuration/cityCategory`,
            title: "City Category",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/holidayConfiguration`,
            title: "Holiday Configuration",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/companyConfiguration`,
            title: "Company Configuration",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/taConfiguration`,
            title: "TA Configuration",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/outCome`,
            title: "Outcome",
            type: "link",
          },
        ],
      },
      {
        title: "Ticketing",
        id: 18,
        icon: "Profile",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/tickets`,
      },
      {
        title: "Survey Management",
        id: 19,
        icon: "Paper",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/category`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/category`,
            title: "Category",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/survey`,
            title: "Surveys",
            type: "link",
          },
        ],
      },
      {
        title: "Offers",
        id: 20,
        icon: "Profile",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/offers`,
      },
      {
        title: "SGPI",
        id: 21,
        icon: "Wallet",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/sgpiMaster`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/sgpiMaster`,
            title: "Master",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/sgpiTransaction`,
            title: "Transaction",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/sgpiBalance`,
            title: "Balance",
            type: "link",
          },
        ],
      },

      {
        title: "Reports",
        id: 22,
        icon: "Wallet",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/adminreports`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/adminreports`,
            title: "Admin Reports",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/myterritories`,
            title: "My Territories",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/employeereport`,
            title: "Employee Report",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/darreport`,
            title: "DAR Report",
            type: "link",
          },
           {
           path:`${process.env.PUBLIC_URL}/masReport`,
           title:'Mas Report',
           type:'link'
          },
           {
           path:`${process.env.PUBLIC_URL}/OnboardingReport`,
           title:'Onboarding Report',
           type:'link'
          },
          {
           path:`${process.env.PUBLIC_URL}/DCRReport`,
           title:'DCR Report',
           type:'link'
          },
          {
            path: `${process.env.PUBLIC_URL}/brandcampaignreport`,
            title: "Brand Campaign Report",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/AttendanceReport`,
            title: "Attendance Report",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/DailyCallReport`,
            title: "Daily Call Report",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/PlanVsActualReport`,
            title: "Plan Vs Actual Report",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/CustomerDataReport`,
            title: "Customer Data Report",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/accountinstructions`,
            title: "Account Instructions",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/paymentsummary`,
            title: "Payment Summary",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/expensesslip`,
            title: "Expenses Slip",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/essoverview`,
            title: "ESS Overview",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/employeesummary`,
            title: "Employee Summary",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/datewisereport`,
            title: "Date Wise Report",
            type: "link",
          },
        ],
      },
      {
        title: "Data Logs",
        id: 23,
        icon: "Wallet",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/dataChange`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dataChange`,
            title: "Data Change",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboardftplogs`,
            title: "Dashboard",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/logs`,
            title: "FTP Logs",
            type: "link",
          },

          {
            path: `${process.env.PUBLIC_URL}/exportlogs`,
            title: "Export Logs",
            type: "link",
          },
        ],
      },
      {
        title: "Settings",
        id: 24,
        icon: "Setting",
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/settings/usermanagement`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/settings/usermanagement`,
            title: "User Management",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/settings/organisationstructure`,
            title: "Organisation Structure",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/settings/masters`,
            title: "Masters",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/settings/supersettings`,
            title: "Super Settings",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/settings/ftpconfigure`,
            title: "FTP Config Settings",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/settings/ftpImportBatches`,
            title: "FTP Import Batches",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/settings/ftpExportBatches`,
            title: "FTP Export Batches",
            type: "link",
          },
        ],
      },
    ],
  },
];
